import React, { useState } from 'react';
import styled from 'styled-components';

import ChartsRouter from 'components/chart/ChartsRouter';
import { ChartsRouterSection } from 'components/chart/chartsRouterTypes';
import HeaderMobile from 'components/layout/header/HeaderMobile';
import MarketHeaderStats from 'components/markets/MarketHeaderStats';
import MarketSelectorMobile from 'components/markets/MarketSelectorMobile';
import BuySellPageMobile from 'components/trading/BuySellPanel/BuySellPageMobile';
import { useIsMobileBuySellRoute } from 'components/trading/dashboardDetect';
import { getDashboardUrl } from 'reduxState/markets/listed/listedMarketsUtils';
import { useSelector } from 'reduxState/storeCore';
import { scrollbarStyle } from 'styleShared';

import DashboardBottomTabs from './DashboardBottomTabs';

const Wrap = styled.div`
  background: var(--mainDark);
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const InnerWrap = styled.div<{ $fluid: boolean }>`
  position: relative;
  padding: 0 4px;
  overflow-x: hidden;
  overflow-y: auto;
  ${scrollbarStyle}
  display: grid;
  grid-template-rows: max-content minmax(min-content, 1fr) max-content;
  grid-template-columns: 100%;
  .isMobileStyle & {
    grid-template-rows: max-content ${({ $fluid }) =>
        $fluid ? 'max-content' : 'minmax(39vh, 1fr)'} max-content;
  }
  gap: 4px;
  flex-direction: column;
  background: var(--mainDark);
  height: 100%;
`;

function DashboardMobile() {
  const isTradeRoute = useIsMobileBuySellRoute();
  const currentMarketPair = useSelector(
    state => state.markets.currentMarket.pair
  );
  const [section, setSection] = useState<ChartsRouterSection>('chart');

  return (
    <Wrap>
      <HeaderMobile
        chainLogo={!isTradeRoute}
        rightContent={<MarketSelectorMobile />}
        backGoTo={
          isTradeRoute
            ? getDashboardUrl('katanaEVMChain', currentMarketPair)
            : undefined
        }
      >
        {isTradeRoute ? 'Place order' : 'Trade'}
      </HeaderMobile>

      {isTradeRoute && <BuySellPageMobile />}

      <InnerWrap
        style={isTradeRoute ? { display: 'none' } : undefined}
        $fluid={section === 'orderBook'}
      >
        <MarketHeaderStats />

        <div>
          <ChartsRouter onChange={setSection} section={section} />
        </div>

        <div>
          <DashboardBottomTabs />
        </div>
      </InnerWrap>
    </Wrap>
  );
}

export default DashboardMobile;
